import { Divider, Grid2 as Grid, List, ListItem, Paper, Typography } from "@mui/material"
import { Label } from "../Typography/Typography"

export interface Detail {
    label: string
    value?: string | number
}

interface DetailsListType {
    details: Detail[]
    disableSurface?: boolean
    label?: string
}

export const DetailsList = ({ details, disableSurface, label }: DetailsListType) => {
    const list = (
        <List disablePadding>
            {details.map((detail, i) => (
                <ListItem key={i} disableGutters divider={i !== details.length - 1}>
                    <Grid container wrap={"nowrap"} sx={{ width: 1 }} spacing={2}>
                        <Grid size={{ xs: 4, md: 2 }}>
                            <Typography variant="caption" color="textSecondary">
                                {detail.label}
                            </Typography>
                        </Grid>
                        <Grid size={"grow"}>
                            <Typography>{detail.value}</Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            ))}
        </List>
    )

    if (disableSurface) {
        return list
    }

    return (
        <Paper sx={{ p: 2 }}>
            {label && <Label gutterBottom="sm">{label}</Label>}
            <Divider />
            {list}
        </Paper>
    )
}
